export const MASK_DATA = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
export const MASK_HORA = [/\d/, /\d/, ':', /\d/, /\d/];

export const OPCOES_REALIZADA = [
  { value: 'P', label: 'Proporcional' },
  { value: 'D', label: 'Desproporcional' },
];

export const OPCOES_PARCERIA = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

export const dadosGeVazio = {
  codigoRazao: 0,
  razaoSocial: '',
  cnpj: '',
  nire: '',
  endereco: '',
  bairro: '',
  cidade: '',
  cep: '',
  nomeContador: '',
  cpfContador: '',
  crcContador: '',
};

export const valoresIniciais = {
  codigoGe: 0,
  dataReuniao: '',
  horaReuniao: '',
  exercicio: new Date().getFullYear() - 1,
  realizadaDeForma: '',
  parceria: '',
  secretario: '',
  lucro: 0,
  socios: [],
};

export const formatarSocioRecebido = (s) => ({
  seq: s.seq,
  nome: s.nome,
  juridica: s.juridica,
  cpfCnpj: s.cpf_cnpj || '',
  cpfCnpjFormatado: s.cpf_cnpj_formatado || '',
  valor: s.valor != null ? Number(s.valor) : 0,
});
